<div class="desc">
    Check whether a domain is available for registration via EPP.
</div>

<div class="row">
    <mat-form-field>
        <mat-label>Domain name</mat-label>
        <input matInput
               placeholder="Domain to check"
               [(ngModel)]="domainName"
               (keydown.enter)="checkAvailability()">
    </mat-form-field>

    <button mat-raised-button
            color="primary"
            (click)="checkAvailability()">Check</button>
</div>
